module.exports = __webpack_public_path__ + "img/bitcoin-btc-logo.a81b6fb6.svg";